import { MouseEvent, useEffect, useRef, useState } from 'react';

interface UseTabsListIndicatorProps {
  ref?: React.MutableRefObject<HTMLDivElement | null>;
  showIndicator: boolean;
  className?: string;
}

export const useTabsListIndicator = ({
  ref,
  showIndicator,
  className,
}: UseTabsListIndicatorProps) => {
  const tabsListRef = useRef<HTMLDivElement>(ref?.current || null);

  const [indicatorWidth, setIndicatorWidth] = useState<number>(0);
  const [indicatorPosition, setIndicatorPosition] = useState<number>(0);

  const onTabClick = (e: MouseEvent<HTMLButtonElement>) => {
    setIndicatorWidth(e.currentTarget.offsetWidth);
    setIndicatorPosition(e.currentTarget.offsetLeft);
  };

  const onPositionSet = (e: Event) => {
    const button = e.currentTarget as HTMLButtonElement;
    setIndicatorWidth(button.offsetWidth);
    setIndicatorPosition(button.offsetLeft);
  };

  useEffect(() => {
    if (!showIndicator) return;
    if (tabsListRef.current) {
      const activeTab = tabsListRef.current.querySelector(
        '[data-state="active"]'
      ) as HTMLElement | null;
      if (!activeTab) return;

      setIndicatorWidth(activeTab.offsetWidth);
      setIndicatorPosition(activeTab.offsetLeft);
    }
  }, [showIndicator, className]);

  useEffect(() => {
    if (!showIndicator) return;
    if (tabsListRef.current) {
      tabsListRef.current
        .querySelectorAll('button[role="tab"]')
        .forEach(tab => tab.addEventListener('click', onPositionSet));
    }
  }, [showIndicator]);

  return {
    onTabClick,
    tabsListRef,
    indicatorWidth,
    indicatorPosition,
  };
};
